import { Validators } from '@angular/forms';
import { ReceivingPersonComponent } from '@ordersnproducts/modules/one-click-order/components/receiving-person/receiving-person.component';
import { OneClickReceivingPersonEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-receiving-person.effects';
import { OneClickTimeWindowsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-time-windows.effects';
import { OneClickElementConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-element-config';
import { OneClickFeatureConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-feature-config';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickMultipleOption } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-is-multiple-option.provider';
import { OneClickLocationProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-multiple-jobsite-displayer.provider';
import { OneClickPreviewTimeWindowLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-time-windows-loading.provider';
import { OneClickReceivingPersonProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-receiving-person.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickTimeWindowProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-time-window.provider';
import { OneClickSetTimeWindow } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-time-window.command.service';
import { OneClickReceivingPersonLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-receiving-person.loader.service';
import { OneClickTimeWindowsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-time-windows.loader.service';
import { OneClickElement } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-element';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { ReceivingPersonValidator } from '@ordersnproducts/modules/shared/validation/receiving-person.validation';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import {
  OneClickHasResultProvider,
  OneClickNoResultProvider,
  OneClickPaymentProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import { FormTextAreaComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-textarea/form-textarea.component';
import { OneClickSetDeliveryInstructionCommand } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-delivery-instruction.command.service';
import { OneClickDeliveryInstructionsProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-instructions.provider';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
    containerClassNames: ['col-4 mb-2 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
    containerClassNames: ['col-4 mb-2 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
    containerClassNames: ['col-md-8 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Quantity,
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-3 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickPreviewField.TimeWindow,
    label: 'views.one_click.time_window',
    placeholder: 'views.one_click.select_time_window',
    optionsLoader: OneClickTimeWindowsLoaderService,
    loading: OneClickPreviewTimeWindowLoadingProvider,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickTimeWindowsEffects],
    onChange: [OneClickSetTimeWindow],
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
    validation: [Validators.required],
    dataTIdLabel: 'cmx-createoneclickorder-seltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-selvaltimewindow',
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.TimeWindow,
    text: OneClickTimeWindowProvider,
    label: 'views.one_click.time_window',
    hidden: OneClickNoResultProvider,
    dataTIdLabel: 'cmx-createoneclickorder-lbltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-lblvaltimewindow',
  } as FieldLabelConfig,
  {
    type: ReceivingPersonComponent,
    name: OneClickPreviewField.ReceivingPerson,
    label: 'views.one_click.receiving_person',
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickReceivingPersonEffects],
    optionsLoader: OneClickReceivingPersonLoaderService,
    validation: [ReceivingPersonValidator],
    containerClassNames: ['col-md-8 text-capitalize retail-control'],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.ReceivingPerson,
    hidden: OneClickNoResultProvider,
    text: OneClickReceivingPersonProvider,
    label: 'views.one_click.receiving_person',
    containerClassNames: ['col-md-8 text-capitalize retail-control'],
  } as FieldLabelConfig,
  {
    type: FormTextAreaComponent,
    label: 'views.one_cick.delivery_instructions',
    name: OneClickPreviewField.SpecialInstructions,
    onChange: [OneClickSetDeliveryInstructionCommand],
    hidden: OneClickHasResultProvider,
    containerClassNames: ['col-md-12 text-capitalize'],
    placeholder: 'views.one_click.enter_comments',
    maxlength: '500',
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    label: 'views.one_cick.delivery_instructions',
    text: OneClickDeliveryInstructionsProvider,
    name: OneClickPreviewField.SpecialInstructions,
    hidden: OneClickNoResultProvider,
    containerClassNames: ['col-md-12 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliveryinstruction',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliveryinstruction',
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12 mt-4'],
    hidden: OneClickHasResultProvider,
    visible: OneClickMultipleOption.IsSingleOption,
  } as FieldConfig,
];

export const features: OneClickFeatureConfig = {
  [OneClickElement.TERMS_AND_CONDITIONS]: {
    name: OneClickElement.TERMS_AND_CONDITIONS,
  } as OneClickElementConfig,
};
